const Icons = {
  check: 'e900',
  checks: 'e901',
  activesessions: 'e902',
  add: 'e903',
  add_reaction: 'e904',
  addboost: 'e905',
  addmember_filled: 'e906',
  adduser: 'e907',
  admin: 'e908',
  ads: 'e909',
  align_center: 'e90a',
  align_left: 'e90b',
  align_right: 'e90c',
  animals: 'e90d',
  animations: 'e90e',
  app_expand: 'e90f',
  app_shrink: 'e910',
  archive: 'e911',
  arrow_down: 'e912',
  arrow_next: 'e913',
  arrow_prev: 'e914',
  arrow_up_circle_fill: 'e915',
  arrowcircle: 'e916',
  arrowhead: 'e917',
  attach: 'e918',
  audio_repeat: 'e919',
  audio_repeat_single: 'e91a',
  author_hidden: 'e91b',
  avatarnext: 'e91c',
  avatarprevious: 'e91d',
  aversion: 'e91e',
  back: 'e91f',
  binfilled: 'e920',
  bold: 'e921',
  bomb: 'e922',
  boost: 'e923',
  boostcircle: 'e924',
  bot_filled: 'e925',
  botcom: 'e926',
  bots: 'e927',
  brightness: 'e928',
  brush: 'e929',
  bubblereply: 'e92a',
  bug: 'e92b',
  calendar: 'e92c',
  calendarfilter: 'e92d',
  camera: 'e92e',
  cameraadd: 'e92f',
  captiondown: 'e930',
  captionup: 'e931',
  car: 'e932',
  card: 'e933',
  card_outline: 'e934',
  cash_circle: 'e935',
  channel: 'e936',
  channel_filled: 'e937',
  channelviews: 'e938',
  chatspinned: 'e939',
  chatsplaceholder: 'e93a',
  check1: 'e93b',
  checkbox: 'e93c',
  checkboxblock: 'e93d',
  checkboxempty: 'e93e',
  checkboxon: 'e93f',
  checklist_add: 'e940',
  checklist_done: 'e941',
  checklist_undone: 'e942',
  checkretract: 'e943',
  checkround: 'e944',
  checkround_filled: 'e945',
  clock: 'e946',
  close: 'e947',
  clouddownload: 'e948',
  collapse: 'e949',
  colorize: 'e94a',
  comments: 'e94b',
  commentssticker: 'e94c',
  contrast: 'e94d',
  copy: 'e94e',
  crop: 'e94f',
  cross: 'e950',
  crossgif: 'e951',
  crossround: 'e952',
  crossround_filled: 'e953',
  crossstar: 'e954',
  crown: 'e955',
  crown_outline: 'e956',
  crownalt: 'e957',
  crownoff: 'e958',
  crownoff_outline: 'e959',
  darkmode: 'e95a',
  data: 'e95b',
  delete: 'e95c',
  delete_filled: 'e95d',
  deletedaccount: 'e95e',
  deleteleft: 'e95f',
  deleteuser: 'e960',
  devices: 'e961',
  document: 'e962',
  dollar_circle: 'e963',
  dollar_circle_x: 'e964',
  down: 'e965',
  down_up: 'e966',
  download: 'e967',
  dragfiles: 'e968',
  dragmedia: 'e969',
  eats: 'e96a',
  edit: 'e96b',
  email: 'e96c',
  endcall_filled: 'e96d',
  enhance: 'e96e',
  enter: 'e96f',
  equalizer: 'e970',
  expand: 'e971',
  eye: 'e972',
  eye1: 'e973',
  eye2: 'e974',
  eyecross_outline: 'e975',
  factcheck: 'e976',
  fade: 'e977',
  fast_forward: 'e978',
  fast_rewind: 'e979',
  favourites: 'e97a',
  flag: 'e97b',
  flip: 'e97c',
  flip_image_horizontal: 'e97d',
  folder: 'e97e',
  fontframe: 'e97f',
  fontframe_bg: 'e980',
  fontframe_outline: 'e981',
  fontsize: 'e982',
  forward: 'e983',
  forward_filled: 'e984',
  free_transform: 'e985',
  fullscreen: 'e986',
  gc_microphone: 'e987',
  gc_microphoneoff: 'e988',
  gem: 'e989',
  gem_exchange: 'e98a',
  gem_transfer: 'e98b',
  gem_transfer_outline: 'e98c',
  geometric_digit_0: 'e98d',
  geometric_digit_1: 'e98e',
  geometric_digit_2: 'e98f',
  geometric_digit_3: 'e990',
  geometric_digit_4: 'e991',
  geometric_digit_5: 'e992',
  geometric_digit_6: 'e993',
  geometric_digit_7: 'e994',
  geometric_digit_8: 'e995',
  geometric_digit_9: 'e996',
  geometric_dot: 'e997',
  geometric_letter_x: 'e998',
  gifs: 'e999',
  gift: 'e99a',
  gift_premium: 'e99b',
  grain: 'e99c',
  group: 'e99d',
  group_filled: 'e99e',
  group_star: 'e99f',
  groupmedia: 'e9a0',
  groupmediaoff: 'e9a1',
  hand: 'e9a2',
  help: 'e9a3',
  hide: 'e9a4',
  highlights: 'e9a5',
  hourglass: 'e9a6',
  image: 'e9a7',
  image_original: 'e9a8',
  info: 'e9a9',
  info2: 'e9aa',
  italic: 'e9ab',
  key: 'e9ac',
  keyboard: 'e9ad',
  lamp: 'e9ae',
  language: 'e9af',
  largepause: 'e9b0',
  largeplay: 'e9b1',
  left: 'e9b2',
  limit_chat: 'e9b3',
  limit_chats: 'e9b4',
  limit_file: 'e9b5',
  limit_folders: 'e9b6',
  limit_link: 'e9b7',
  limit_pin: 'e9b8',
  link: 'e9b9',
  link_paid: 'e9ba',
  list: 'e9bb',
  listscreenshare: 'e9bc',
  livelocation: 'e9bd',
  location: 'e9be',
  lock: 'e9bf',
  lockoff: 'e9c0',
  loginlogodesktop: 'e9c1',
  loginlogomobile: 'e9c2',
  logout: 'e9c3',
  mac_command_key: 'e9c4',
  mediaspeed_empty: 'e9c5',
  mediaspoiler: 'e9c6',
  mediaspoileroff: 'e9c7',
  mention: 'e9c8',
  menu: 'e9c9',
  menu_feature_cover: 'e9ca',
  menu_feature_unique: 'e9cb',
  menu_verification: 'e9cc',
  message: 'e9cd',
  message_jump: 'e9ce',
  message_quote: 'e9cf',
  messageunread: 'e9d0',
  microphone: 'e9d1',
  microphone_crossed: 'e9d2',
  microphone_crossed_filled: 'e9d3',
  microphone_filled: 'e9d4',
  minus: 'e9d5',
  monospace: 'e9d6',
  more: 'e9d7',
  multistories: 'e9d8',
  mute: 'e9d9',
  muted: 'e9da',
  mynotes: 'e9db',
  newchannel: 'e9dc',
  newchannel_filled: 'e9dd',
  newchat_filled: 'e9de',
  newgroup: 'e9df',
  newgroup_filled: 'e9e0',
  newprivate: 'e9e1',
  newprivate_filled: 'e9e2',
  newtab: 'e9e3',
  next: 'e9e4',
  nochannel: 'e9e5',
  noncontacts: 'e9e6',
  nosound: 'e9e7',
  okay: 'e9e8',
  online: 'e9e9',
  passwordoff: 'e9ea',
  pause: 'e9eb',
  permissions: 'e9ec',
  person: 'e9ed',
  phone: 'e9ee',
  phone_filled: 'e9ef',
  pin: 'e9f0',
  pin2: 'e9f1',
  pinlist: 'e9f2',
  pinned_filled: 'e9f3',
  pinnedchat: 'e9f4',
  pip: 'e9f5',
  play: 'e9f6',
  playback_05: 'e9f7',
  playback_15: 'e9f8',
  playback_1x: 'e9f9',
  playback_2x: 'e9fa',
  plus: 'e9fb',
  plusround: 'e9fc',
  poll: 'e9fd',
  premium_addone: 'e9fe',
  premium_avatars: 'e9ff',
  premium_badge: 'ea00',
  premium_colors: 'ea01',
  premium_double: 'ea02',
  premium_emoji: 'ea03',
  premium_filesize: 'ea04',
  premium_lastseen: 'ea05',
  premium_limits: 'ea06',
  premium_lock: 'ea07',
  premium_management: 'ea08',
  premium_noads: 'ea09',
  premium_privacy: 'ea0a',
  premium_reactions: 'ea0b',
  premium_restrict: 'ea0c',
  premium_speed: 'ea0d',
  premium_status: 'ea0e',
  premium_stickers: 'ea0f',
  premium_tags: 'ea10',
  premium_transcription: 'ea11',
  premium_translate: 'ea12',
  premium_unlock: 'ea13',
  premium_wallpaper: 'ea14',
  previous: 'ea15',
  promote: 'ea16',
  quote: 'ea17',
  quote_outline: 'ea18',
  radiooff: 'ea19',
  radioon: 'ea1a',
  reactions: 'ea1b',
  reactions_filled: 'ea1c',
  readchats: 'ea1d',
  recent: 'ea1e',
  redo: 'ea1f',
  reload_star: 'ea20',
  replace: 'ea21',
  reply: 'ea22',
  reply_filled: 'ea23',
  restrict: 'ea24',
  revenue: 'ea25',
  rightpanel: 'ea26',
  rotate: 'ea27',
  rotate_left: 'ea28',
  rotate_right: 'ea29',
  round_chats_filled: 'ea2a',
  saturation: 'ea2b',
  saved: 'ea2c',
  savedmessages: 'ea2d',
  schedule: 'ea2e',
  scheduled: 'ea2f',
  search: 'ea30',
  select: 'ea31',
  send: 'ea32',
  send2: 'ea33',
  sending: 'ea34',
  sendingerror: 'ea35',
  settings: 'ea36',
  settings_clipped_corner: 'ea37',
  settings_filled: 'ea38',
  shadows: 'ea39',
  sharescreen_filled: 'ea3a',
  sharpen: 'ea3b',
  shipping: 'ea3c',
  shuffle: 'ea3d',
  smallscreen: 'ea3e',
  smile: 'ea3f',
  sort_date: 'ea40',
  sort_num: 'ea41',
  sort_price: 'ea42',
  speaker: 'ea43',
  speakerfilled: 'ea44',
  speakeroff: 'ea45',
  speakerofffilled: 'ea46',
  spoiler: 'ea47',
  sport: 'ea48',
  star: 'ea49',
  star_filled: 'ea4a',
  statistics: 'ea4b',
  stickers: 'ea4c',
  stickers_face: 'ea4d',
  stop: 'ea4e',
  stories: 'ea4f',
  storyreply: 'ea50',
  storyrepost: 'ea51',
  strikethrough: 'ea52',
  suggested: 'ea53',
  tag: 'ea54',
  tag_add: 'ea55',
  tag_alt: 'ea56',
  tag_alt_crossed: 'ea57',
  tag_alt_outline: 'ea58',
  tag_crossed: 'ea59',
  tag_filter: 'ea5a',
  tag_name: 'ea5b',
  text: 'ea5c',
  textedit: 'ea5d',
  time_lock: 'ea5e',
  timer: 'ea5f',
  tip: 'ea60',
  ton: 'ea61',
  tools: 'ea62',
  topics: 'ea63',
  trade: 'ea64',
  transcribe: 'ea65',
  unarchive: 'ea66',
  unclaimed: 'ea67',
  underline: 'ea68',
  undo: 'ea69',
  unmute: 'ea6a',
  unpack: 'ea6b',
  unpin: 'ea6c',
  unread: 'ea6d',
  up: 'ea6e',
  up_down: 'ea6f',
  user: 'ea70',
  username: 'ea71',
  videocamera: 'ea72',
  videocamera_crossed_filled: 'ea73',
  videocamera_filled: 'ea74',
  videochat: 'ea75',
  vignette: 'ea76',
  volume_down: 'ea77',
  volume_mute: 'ea78',
  volume_off: 'ea79',
  volume_up: 'ea7a',
  warmth: 'ea7b',
  warning: 'ea7c',
  webview: 'ea7d',
  win_key: 'ea7e',
  zoomin: 'ea7f',
  zoomout: 'ea80'
};

export default Icons;
